import axios, { AxiosRequestConfig } from 'axios';
import merge from 'deepmerge';
import apiConfig from './apiConfig';
import AuthProtect from 'common/enums/AuthProtect';
import { store } from 'store';
import { IEndpoint } from 'interfaces/IEndPoint';

const genericErrorMessage =
  'We just experienced a technical issue, please wait a few seconds and try again.';

function apiFetchMagic<T>(api: IEndpoint): Promise<{ status: number; data: T }> {
  const headers: AxiosRequestConfig = {};
  const params: any = api.params || {}; // eslint-disable-line
  const baseURL = apiConfig.baseURL;

  // Todo: Create API Token to params
  if (api.authorization === AuthProtect.REQUIRED) {
    const token = store.getState().token.authorization;
    if (token) {
      params.access_token = token; // eslint-disable-line
    }
  }
  const apiConfigMerge: AxiosRequestConfig = merge.all([
    apiConfig,
    api,
    {
      baseURL,
      headers,
      params,
    },
  ]);

  const axiosCreate = axios.create(apiConfigMerge);

  axiosCreate.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  return axiosCreate({
    ...apiConfigMerge,
    validateStatus: (status: number) => {
      return status < 500;
    },
  })
    .catch((e) => {
      console.log('Magic catch:', e);
      throw {
        message: genericErrorMessage,
      };
    })
    .then((response) => {
      if (response.status === 401 || response.status === 403) {
        throw {
          message: 'Submitted credentials is expired or invalid.',
        };
      }
      if (response.status === 400) {
        throw {
          message: response.data.error?.code || 'Submitted credentials is expired or invalid.',
        };
      }

      return {
        status: response.status,
        data: response.data,
      };
    });
}

export default apiFetchMagic;
